module.exports = __webpack_public_path__ + "img/baemin.49eafffe.png";